import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Filter.svg",
  "use": "Filter.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Filter.svg\"><path d=\"M32.0209,56.0208a24,24,0,1,1,24-24A24,24,0,0,1,32.0209,56.0208Zm0-44a20,20,0,1,0,20,20A20,20,0,0,0,32.0209,12.0208Zm12,16h-24a2,2,0,1,1,0-4h24a2,2,0,1,1,0,4Zm-20,4h16a2,2,0,1,1,0,4h-16a2,2,0,1,1,0-4Zm4,8h8a2,2,0,1,1,0,4h-8a2,2,0,1,1,0-4Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol